/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstFloatOpts, SchemaConstFloat, ISchemaConstFloat } from "../const/SchemaConstFloat";
import { ISchemaValue, ISchemaValueOpts, SchemaValue } from "./SchemaValue";

export interface ISchemaValueFloatOpts extends ISchemaValueOpts<ISchemaConstFloat>, ISchemaConstFloatOpts {}

/**
 * Schema: Float value
 *
 * @param opts Schema options
 */
export function SchemaValueFloat(opts: ISchemaValueFloatOpts): ISchemaValue<ISchemaConstFloat> {

	return SchemaValue(SchemaConstFloat(opts), opts);

}